module.exports = __webpack_public_path__ + "static/media/icons-ic-callback-connect.a2d447db.svg";